import invoicesApi from '../../api/invoices-api';
import router from '@/router';

const invoices = {
  items: [],
  item: {},
  itemsTotal: 0,
};

const mutations = {
  setItemInvoice (state, payload) {
    state.item = payload;
  },
  setItemsInvoices (state, payload) {
    state.items = payload.data;
  },
  setItemsTotalInvoices (state, payload) {
    state.itemsTotal = payload;
  },
};

const actions = {
  async refreshInvoices (
    context,
    { restaurant_id, page, per_page, search = '', date_from = '', date_to = '', language },
  ) {
    if (!restaurant_id) {
      restaurant_id = this.getters.getCurrentRestaurant;
    }
    context.commit('loading', true);
    const res = await invoicesApi.getAllByRestaurant(
      restaurant_id,
      page,
      per_page,
      search,
      date_from,
      date_to,
      language,
    );
    context.commit('loading', false);
    context.commit('setItemsInvoices', res.data);
    context.commit('setItemsTotalInvoices', res.data.meta.total);
  },
  async getInvoice (context, { id, language }) {
    context.commit('setItemInvoice', {});
    const res = await invoicesApi.getOne(id, language);
    context.commit('setItemInvoice', res.data.data);
  },
  downloadInvoice ({ commit }, id) {
    commit('loading', true);
    invoicesApi.download(id).then(
      (response) => {
        const file = new Blob([response.data], { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        window.open(fileURL);
        commit('loading', false);
      },
      (error) => {
        commit('loading', false);
      },
    );
  },
  createInvoice ({ commit, dispatch }, { id, invoice, language }) {
    commit('loading', true);
    invoicesApi.create(id, invoice, language).then(
      (response) => {
        commit('notifications', { title: 'Factura creada' });
        commit('loading', false);
        dispatch('downloadInvoice', response.data.id);
        router.push({ name: 'tickets' });
        commit('showNotifications', true);
      },
      (error) => {
        console.log(error);
        if (error.toString().includes('403')) {
          commit('notifications', { title: 'No ha sido posible crear la factura', text: 'Las facturas se pueden pedir en un plazo de 24H después de la finalización de la comanda.', color: 'danger' });
        } else {
          commit('notifications', { title: 'No ha sido posible crear la factura', color: 'danger' });
        }
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
  editInvoice ({ commit, dispatch }, { id, invoice, language }) {
    commit('loading', true);
    invoicesApi.edit(id, invoice, language).then(
      (response) => {
        commit('notifications', { title: 'Factura editada' });
        commit('loading', false);
        dispatch('downloadInvoice', response.data.id);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', { title: 'No ha sido posible editar la factura', color: 'danger' });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
};

const getters = {
  getInvoice: (state) => state.item,
  getInvoices: (state) => state.items,
  getInvoicesTotal: (state) => state.itemsTotal,
};

export default {
  state: invoices,
  mutations,
  actions,
  getters,
};
